import API from '@/views/Fdc/Apis/'

/**
 * Admin > Virtual Manager
 * Virtual EAP 실해 ㅇ관리
 */
export default {
  name: 'virtualManager',
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.listVirtualEap()
  },
  methods: {
    /**
     * Columns initialize
     */
    initColumns () {
      const self = this
      // const connTypeList = ['REST_API', 'WEBSOCKET', 'TIBRV', 'RABBITMQ']
      this.columns = [
        // { headerName: 'Connection Type', field: 'connType', width: 200, required: true, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: connTypeList } },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 110, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 110, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 110, required: true, editable: function (params) { return params.node.data.eapStatus === 'IDLE' } },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.PARAM_START'), field: 'paramStart', width: 110, required: true, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn', hide: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.PARAM_END'), field: 'paramEnd', width: 110, required: true, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn', hide: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.DATA_COUNT'), field: 'dataCount', width: 110, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.INTERVAL'), field: 'dataInterval', width: 110, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.WAFER_IDLE_TIME'), field: 'waferIdleTime', width: 130, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.LOT_IDLE_TIME'), field: 'lotIdleTime', width: 130, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.WAFER_COUNT'), field: 'waferCount', width: 110, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.STEP_COUNT'), field: 'stepCount', width: 110, required: false, editable: function (params) { return params.node.data.eapStatus === 'IDLE' }, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 },
        {
          headerName: ' ',
          field: 'eapStatus',
          width: 110,
          cellRendererSelector: function (params) {
            const startBtn = {
              frameworkComponent: 'buttonRenderer',
              params: {
                clicked: function (params) {
                  self.executeVirtualEap(params)
                },
                btnType: 'is-primary',
                btnIcon: 'play',
                btnLabel: 'Start'
              }
            }

            const stopBtn = {
              frameworkComponent: 'buttonRenderer',
              params: {
                clicked: function (params) {
                  self.executeVirtualEap(params)
                },
                btnType: 'is-light',
                btnIcon: 'stop',
                btnLabel: 'Stop'
              }
            }

            if (params.data.eapStatus === 'RUN') return stopBtn
            else if (params.data.eapStatus === 'IDLE') return startBtn
            else return undefined
          }
          // cellRenderer: 'buttonRenderer',
          // cellRendererParams: {
          //   clicked: function (params) {
          //     // self.openRealTimeMonitor(params)
          //   }, // button click event 설정
          //   btnIcon: 'chart-line' // button icon 설정
          //   // btnTitle: 'Real Time Monitor' // button title 설정
          //   // btnStyle: 'height: 20px;' // button 추가 style 설정
          //   // btnLabel: 'Monitor' // button text 설정
          // }
        }
      ]
    },
    /**
     * Virtual Manager 목록 조회
     */
    async listVirtualEap () {
      let data = await API.Admin.getVirtualEaps()
      this.rowData = data
      this.originRowData = data
    },
    /**
     * Virtual EAP execute
     * @param {*} params
     */
    executeVirtualEap (params) {
      let action
      let confirmDialogTitle
      let item = params.data

      switch (item.eapStatus) {
        case 'IDLE':
          action = 'START'
          confirmDialogTitle = `${this.message.confirmVirtualEapPrefix} ${this.message.start} ${this.message.confirmVirtualEapPostfix}`
          break
        case 'RUN':
          action = 'STOP'
          confirmDialogTitle = `${this.message.confirmVirtualEapPrefix} ${this.message.stop} ${this.message.confirmVirtualEapPostfix}`
          break
      }

      const payload = {
        // connType: item.connType,
        fab: item.fab,
        eqpId: item.eqpId,
        recipeId: item.recipeId,
        paramStart: item.paramStart,
        paramEnd: item.paramEnd,
        dataCount: item.dataCount,
        dataInterval: item.dataInterval,
        waferIdleTime: item.waferIdleTime,
        lotIdleTime: item.lotIdleTime,
        waferCount: item.waferCount,
        stepCount: item.stepCount
      }

      let self = this

      this.$dialog.confirm({
        title: confirmDialogTitle,
        message: `Fab : ${payload.fab}<br>Eqp ID : ${payload.eqpId}</p>`,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: async () => {
          let response
          switch (action) {
            case 'START':
              response = await API.Admin.runVirtualEapStart(payload)
              break
            case 'STOP':
              response = await API.Admin.runVirtualEapStop(payload)
              break
          }
          if (response.status === 200 && response.data) {
            self.listVirtualEap()
            // self.$toast.open('Success')
            self.$toast.open(this.$t('fdc.COMMON.MESSAGE.SUCCEED_EXEC_REQ'))
          }
        },
        onCancel: () => {}
      })
    }
  },
  data () {
    return {
      virtualManagerGrid: null, // Virtual Manager grid 객체
      message: {
        confirmVirtualEapPrefix: this.$t('fdc.MANAGEMENT.MESSAGE.VIRTUAL_EAP_CONFIRM_PREFIX'),
        confirmVirtualEapPostfix: this.$t('fdc.MANAGEMENT.MESSAGE.VIRTUAL_EAP_CONFIRM_POSTFIX'),
        start: this.$t('fdc.MANAGEMENT.MESSAGE.START'),
        stop: this.$t('fdc.MANAGEMENT.MESSAGE.STOP')
      }, // 다국어 message 배열
      columns: [], // Virtual Manager grid column배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 110, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 110, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 110, required: true, modifiable: true },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.PARAM_START'), binding: 'paramStart', width: 110, required: true, modifiable: true, dataType: 'Number', visible: false },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.PARAM_END'), binding: 'paramEnd', width: 110, required: true, modifiable: true, dataType: 'Number', visible: false },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.DATA_COUNT'), binding: 'dataCount', width: 110, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.INTERVAL'), binding: 'dataInterval', width: 110, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.WAFER_IDLE_TIME'), binding: 'waferIdleTime', width: 130, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.LOT_IDLE_TIME'), binding: 'lotIdleTime', width: 130, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.WAFER_COUNT'), binding: 'waferCount', width: 110, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.MANAGEMENT.COLUMN.STEP_COUNT'), binding: 'stepCount', width: 110, required: false, modifiable: true, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 160, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true },
      //   { label: ' ', binding: 'eapStatus', width: 110, readOnly: true, dataMap: false }
      // ], // Virtual Manager grid column배열
      rowData: [], // Virtual Manager grid row data
      originRowData: [], // Virtual Manager grid row data
      collectionViewOptions: {
        groupDescriptions: ['fab']
      } // Virtual Manager grid collectionView Option
    }
  }
}
